import { FC } from 'react';
import type { ConfirmRemoveDocumentProps } from './ConfirmRemoveDocument.types';
import { Button, ButtonGroup, Card, Flex, Text } from '@/_components';

export const ConfirmRemoveDocument: FC<ConfirmRemoveDocumentProps> = ({
  onCancel,
  onConfirm,
}) => {
  return (
    <Card padding={8}>
      <Flex isColumn={true} gap={6}>
        <Text type="small">
          All files that were uploaded to this question will be permanently
          deleted. Are you sure you want to proceed?
        </Text>
        <ButtonGroup isSameLine={true} isSmallGroup={true} align="right">
          <Button
            onClick={onCancel}
            value="No"
            intent="danger-secondary"
            size="small"
          />
          <Button
            onClick={onConfirm}
            value="Yes"
            intent="primary"
            size="small"
          />
        </ButtonGroup>
      </Flex>
    </Card>
  );
};
